<template>
  <div
    v-if="list.length > 0"
    class="Component__TemplateMasonry"
    :class="{
      bestWrapper: template_source === TEMPLATE_SOURCE.BEST_PRACTICE_PAGE,
    }"
  >
    <CardItem
      v-for="item in list"
      :key="item.id"
      :data="item"
      class="card"
      :class="{ 'card-vertical': item.resolution === '1080x1920' }"
      :auto-scale="true"
      :source="template_source"
      @change="onChange($event, item)"
      @click="onHandleClick(item)"
    >
      {{ item.name }}
    </CardItem>
  </div>
  <EmptyView v-else-if="!loading" :style="{ background: 'none' }"></EmptyView>
</template>

<script setup lang="ts">
import type { Template } from '~/api/interface';
import EmptyView from '~/components/emptyView/index.vue';
import CardItem from '~/features/template/components/cardItem.vue';
import { getTagIDs } from '~/features/template/components/info';
import { useTemplateDetail } from '~/hooks/useModal/modals/template';
import { TEMPLATE_SOURCE, TRACK_EVENT } from '~/utils/track';

const props = withDefaults(
  defineProps<{
    list: Template[];
    loading?: boolean;
    template_source: TEMPLATE_SOURCE;
    width?: number;
    onCardClick?: (data: Template) => void;
  }>(),
  {
    loading: false,
    width: undefined,
  },
);

const onChange = ([key, value]: [string, any], data: Template) => {
  const item: any = props.list.find(item => {
    return item.id === data.id;
  });
  if (item) {
    item[key] = value;
  }
};

const resourceLocation = injectResourceLocation();
const userInfo = useUserInfo();

const onHandleClick = (data: Template) => {
  const trackParams = {
    template_id: data.id,
    template_title: data.name,
    source: resourceLocation?.source,
    tags: getTagIDs(data.tag_ids).map(item => item.tag_name),
    org_id: userInfo.value?.organization_id,
  };

  if (props.template_source === TEMPLATE_SOURCE.BEST_PRACTICE_PAGE) {
    trackEvent(TRACK_EVENT.CLICK_EXCELLENT_WORK, trackParams);
  } else {
    trackEvent(TRACK_EVENT.CLICK_TEMPLATE_PREVIEW, trackParams);
  }

  if (props.onCardClick) {
    props.onCardClick(data);
  } else {
    useTemplateDetail(
      props.list,
      data,
      {
        templateSource: props.template_source,
        source: resourceLocation?.source,
      },
      onChange,
    );
  }
};
</script>

<style lang="scss" scoped>
.Component__TemplateMasonry {
  display: grid;

  grid-template-columns: repeat(5, 1fr);
  // grid-auto-rows: 226px;
  grid-auto-rows: 12vw;
  grid-auto-flow: dense;
  gap: 14px;

  @media screen and (max-width: 1700px) {
    grid-template-columns: repeat(4, 1fr);
    // grid-auto-rows: 200px;
    grid-auto-rows: 15vw;
  }

  @media screen and (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
    // grid-auto-rows: 180px;
    grid-auto-rows: 26vw;
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: 48vw;
  }

  @media screen and (max-width: 414px) {
    grid-template-columns: 1fr;
    grid-auto-rows: 60vw;
  }

  .card {
    box-sizing: content-box;
    background-color: var(--back-1);
    height: 100%;
  }

  .card-vertical {
    grid-row: span 2;
  }
}
.bestWrapper {
  display: grid;
  margin-top: 30px;
  grid-template-columns: repeat(5, 1fr);
  grid-auto-rows: 246px;
  grid-auto-flow: dense;
  gap: 14px;
}
</style>
